import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Button/Button';
import { ReactComponent as IconDiamond } from '../../public/images/svg/icon_diamond.svg';

const MetaAndSummaryButton = ({ onClick }) => {
  return (
    <Button
      type="button"
      className="bg-transparent w-56 p-4 border border-solid border-purple-200 text-purple-200 flex gap-4 font-medium"
      name="meta-and-summary"
      onClick={onClick}
      dataTest="meta-and-summary-button"
      label="Meta & Summary"
      icon={<IconDiamond />}
    />
  );
};

MetaAndSummaryButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default MetaAndSummaryButton;
